import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import { getXsrfToken } from "../cgi/cookies";
import { DriveRequest } from "../common/drive-request";
import { DriveApiError } from "../common/error";
import { requestV1Cgi, RetCode } from "../data-source/network-request";

/**
 * 置顶.
 */
export function collaborationSpacePin(params) {
  return new CollaborationSpacePinRequest(params).send();
}

/**
 * 取消置顶.
 */
export function collaborationSpaceUnpin(params) {
  return new CollaborationSpaceUnpinRequest(params).send();
}
/**
 * 置顶.
 */
export var CollaborationSpacePinRequest = /*#__PURE__*/function (_DriveRequest) {
  _inherits(CollaborationSpacePinRequest, _DriveRequest);
  var _super = _createSuper(CollaborationSpacePinRequest);
  function CollaborationSpacePinRequest() {
    _classCallCheck(this, CollaborationSpacePinRequest);
    return _super.apply(this, arguments);
  }
  _createClass(CollaborationSpacePinRequest, [{
    key: "request",
    value: function request(payload) {
      return requestV1Cgi(payload);
    }
  }, {
    key: "getPayload",
    value: function getPayload(params) {
      return {
        method: 'post',
        url: "/api/file/collaboration/space/pin?xsrf=".concat(getXsrfToken()),
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          file_id: params.id,
          is_pin: params.isPinned
        }
      };
    }
  }, {
    key: "getResult",
    value: function getResult(response) {
      if (response.retcode !== RetCode.Success) {
        throw new DriveApiError({
          name: 'PinResultError',
          message: response.msg,
          params: this.params,
          payload: this.payload,
          response: response
        });
      }
    }
  }]);
  return CollaborationSpacePinRequest;
}(DriveRequest);

/**
 * 取消置顶.
 */
export var CollaborationSpaceUnpinRequest = /*#__PURE__*/function (_DriveRequest2) {
  _inherits(CollaborationSpaceUnpinRequest, _DriveRequest2);
  var _super2 = _createSuper(CollaborationSpaceUnpinRequest);
  function CollaborationSpaceUnpinRequest() {
    _classCallCheck(this, CollaborationSpaceUnpinRequest);
    return _super2.apply(this, arguments);
  }
  _createClass(CollaborationSpaceUnpinRequest, [{
    key: "request",
    value: function request(payload) {
      return requestV1Cgi(payload);
    }
  }, {
    key: "getPayload",
    value: function getPayload(params) {
      return {
        method: 'post',
        url: "/api/file/collaboration/space/pin?xsrf=".concat(getXsrfToken()),
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          file_id: params.id,
          is_pin: params.isPinned
        }
      };
    }
  }, {
    key: "getResult",
    value: function getResult(response) {
      if (response.retcode !== RetCode.Success) {
        throw new DriveApiError({
          name: 'UnpinResultError',
          message: response.msg,
          params: this.params,
          payload: this.payload,
          response: response
        });
      }
    }
  }]);
  return CollaborationSpaceUnpinRequest;
}(DriveRequest);
//# sourceMappingURL=collaboration-space-pin.js.map